import React from "react"
import { Button } from "@mui/material"
import { AppSvg } from "../../components"

import { HeaderOuter,HeaderLogo,  RightMenu, HeaderLabel } from "./styles"

function Header() {
	const handleGetStarted = () => {
		process.env.ENV === "prod"
			? window.open("https://client.onepulse.com/welcome", "_blank")
			: window.open("https://beta-v3.onepulse.com/welcome", "_blank")
	}

	return (
		<HeaderOuter>
		<HeaderLogo>
		<AppSvg type={'onepulse'} />
		</HeaderLogo>


			<RightMenu>
			<HeaderLabel>Want to send your first Pulse?</HeaderLabel>
			<div>
				<Button variant='contained' size={'mediun'} onClick={handleGetStarted}>
					Get Started
				</Button>
				</div>
		</RightMenu>

		</HeaderOuter>
	)
}

export default Header
